<template>
  <LinkBasic
    :text="props.nameBtn"
    :link="props.link"
    :isBlank="props.isBlank"
    :class="['btn_basic', props.style]"
  />
  <!-- 사용시
  <ButtonBasic
    :nameBtn="'목록으로'"
    :link="'/'"
    :style="'type_black'"
  /> -->
</template>
<script setup>
const props = defineProps({
  link: {
    type: String,
    default: '',
  },
  nameBtn: {
    type: String,
    default: '',
  },
  isBlank: {
    type: Boolean,
    default: false,
  },
  style: {
    type: String,
    default: '',
  },
});
</script>
<style lang="scss" scoped>
.btn_basic {
  display: inline-block;
  min-width: 240px;
  height: 60px;
  margin: 0 4px;
  font-size: 16px;
  font-weight: 500;
  line-height: 60px;
  text-align: center;
  border-radius: 10px;
  transition: all 0.3s;
  &.type_black {
    background-color: #1a1a1a;
    color: #fff;
  }
  &.type_white {
    background-color: #fff;
    color: #1a1a1a;
    outline: 1px solid #b3b3b3;
    &:hover {
      outline: 1px solid #1a1a1a;
    }
  }
}
@media screen and (max-width: 811px) {
  //모바일 스타일
  .btn_basic {
    width: 100%;
    min-width: auto;
    height: 48px;
    font-size: 14px;
    line-height: 48px;
    border-radius: 8px;
  }
}
</style>
